import React, { Component } from 'react';
import {
  Route,
  Switch
} from 'react-router-dom';
import AppHeader from '../common/AppHeader';
import ChangePassword from '../user/login/ChangePassword'
import NotFound from '../common/NotFound';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import CookieConsent from "react-cookie-consent";
import AppTheme from '../environment/client/themes/AppTheme';

const useStyles = theme => ({
  toolbar: theme.mixins.toolbar,
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    paddingBottom: theme.spacing(6),
    overflow: 'auto',
  },
  footerBar: {
    top: 'auto',
    bottom: 0,
    height: '50px',
    opacity: "0.5",
    zIndex: '-1',
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    const { classes } = this.props;

    return (
      <AppTheme>
        <div className={classes.root}>
          <CssBaseline />
          <AppHeader authenticated={this.state.authenticated} onLogout={this.handleLogout} currentUser={this.state.currentUser} />
          <main className={classes.content}>
            <div className={classes.toolbar}> </div>
            <Switch>
              <Route path="/changePassword" render={(props) => <ChangePassword authenticated={this.state.authenticated} {...props} />}></Route>
              <Route exact path="/" render={(props) => <ChangePassword authenticated={this.state.authenticated} {...props} />}></Route>
              <Route component={NotFound}></Route>
            </Switch>
            <Alert stack={{ limit: 3 }} timeout={4000} effect='slide' position="bottom-left" />
          </main>
          <CookieConsent>This website uses cookies to enhance the user experience.</CookieConsent>
        </div>

      </AppTheme>
    );
  }
}

export default withStyles(useStyles)(App);
